import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import PlanPeriod from '../PlanPeriod';
import { readPlanParam } from '../../../../../shared/helpers/functions/navigation';
import { Plan } from '../../../../../shared/helpers/constants/plans';
import AnnualSubscriptionDetails from '../AnnualSubscriptionDetails';
import MonthlySubscriptionDetails from '../MonthlySubscriptionDetails';

export default function PlanDetails() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const plan = readPlanParam(searchParams) as Plan;

  let detailsComponent;

  if (plan === Plan.annual) {
    detailsComponent = <AnnualSubscriptionDetails />;
  } else if (plan === Plan.monthly) {
    detailsComponent = <MonthlySubscriptionDetails />;
  }

  return (
    <Box
      sx={(theme) => ({
        width: { xs: '100%', sm: 'auto' },
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '540px',
        paddingLeft: { md: 1 },
        backgroundColor: theme.palette.common.white,
        height: 'min-content',
      })}
    >
      <Typography variant="h4" sx={{ mb: 3 }}>
        {t('checkout.title')}
      </Typography>
      <Box>
        <PlanPeriod />
        {detailsComponent}
      </Box>
    </Box>
  );
}
